export default __webpack_public_path__ + "static/media/fing.a395b2ac.png";